@import (reference) '../../../../../../../constants/spacing.module.less';

.tote-info-label {
  color: var(--grey-700);
  display: flex;
  align-items: center;
  gap: @space-4;
}

.tote-info-icon {
  width: 14px;
  height: 14px;
  color: var(--grey-700);
}
